import axios from "axios";
import { CompanyID, EmployeeID } from "configs/AppConfig";
import AuthService from "services/AuthService";
import { generateNumRandomId } from "views/app-views/servicedesk/components/GetRandomId";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(async (config) => {
  const randomId = generateNumRandomId(8);
  // Fetch the bearer token from local storage
  const bearerToken = localStorage.getItem('bearerToken');

  config.headers.Authorization = `Bearer ${bearerToken}`;
  config.headers.Accept = "application/json";
  config.headers['Accrue-Client'] = "AdminPanel";
  config.headers.EmployeeID = EmployeeID;
  config.headers['Tenant-Id'] = CompanyID;
  config.headers['companyId'] = CompanyID;
  config.headers['traceId'] = randomId;

  // Initialize or increment retry count on this request
  config.retryCount = config.retryCount || 0;

  return config;
}, (error) => {
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.log('triggered')
      // If response is 401, increment retry count
      error.config.retryCount++;

      // If more than three attempts, sign out
      if (error.config.retryCount > 3) {
        localStorage.setItem("Permissions", JSON.stringify(null));
        // AuthService.signOut();
        return Promise.reject(error);
      }

      // Refresh the token
      await AuthService.refreshToken();

      // Fetch the new bearer token from local storage
      const newBearerToken = localStorage.getItem('bearerToken');

      // Update the Authorization header
      error.config.headers.Authorization = `Bearer ${newBearerToken}`;

      // Retry the API call
      return axios(error.config);
    } else {
      console.log(error);
      if (error.response && error.response.status === 400 && error.config.skip400ErrorMessage) {
        // If it's a 400 error and skipping is requested, reject the promise without handling
        return Promise.reject(error);
      }
  
      // For all other cases, including when skip400ErrorMessage is not true, call the status handler
      AuthService.statusHandler(error.response);
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
